export class SelectionListItem {
    constructor(
      public id: string,
      public name: string,
      public descriptions: string[],
      public location: string,
      public target: string,
      public checkHandler) { };
}



// WEBPACK FOOTER //
// ./src/app/shared/selectionList/selectionlistitem.model.ts